teamaterial<template>
  <div class="maincen">
    <div class="catalog">
      <div class="line"></div>
      <div class="catalogTit">我要出版</div>
      <div class="publishBut" @click="publishdialogVisible = true">申请出版图书>></div>
    </div>
    <div class="center">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="审核中" name="0">
        </el-tab-pane>
        <el-tab-pane label="已审核" name="2">
        </el-tab-pane>
      </el-tabs>
      <el-collapse accordion>
            <el-collapse-item v-for="item in publishList" :key="item.fid">
              <template slot="title">
                <div class="Tit">
                  <div :class=" item.pubStatus == 2?'status restatus':'status' ">{{item.statusStr}}</div>
                  <div class="name">{{item.pubBookname}}</div>
                  <div class="time">{{item.pubAddtime}}</div>
                </div>
              </template>
              <div class="details">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <div class="detItem">申请人：{{item.name}}</div>
                      <div class="detItem">手机号：{{item.phone}}</div>
                      <div class="detItem">书名：{{item.pubBookname}}</div>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="grid-content bg-purple">
                      <div class="detItem">所属院校：{{item.schName}}</div>
                      <div class="detItem">书号:{{item.pubBooknum}}</div>
                      <div class="detItem">套数：{{item.pubSet}}套</div>
                      <div class="detItem">申请说明：{{item.pubIntro?item.pubIntro:''}}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
      </el-collapse>
    </div>
    <!-- 教师账号样书申请-->
    <el-dialog title :visible.sync="publishdialogVisible" width="35%" :before-close="handleClose">
      <div class="matbox">
        <div class="matTip">请填写您要申请出版的图书、论文、学术等相关内容，我们工作人员会尽快与您联系。</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名">
            <el-input v-model="userData.name" :disabled="true" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机">
            <el-input v-model="userData.phone" :disabled="true" placeholder="请输入您的手机号"></el-input>
          </el-form-item>
          <el-form-item label="书籍名称" prop="pubBookname">
            <el-input v-model="ruleForm.pubBookname" placeholder="请输入您要申请的书籍名称"></el-input>
          </el-form-item>
          <el-form-item label="书号" prop="pubBooknum">
            <el-input v-model="ruleForm.pubBooknum" placeholder="请输入您要申请的书号"></el-input>
          </el-form-item>
          <el-form-item label="学校名称">
            <el-input v-model="userData.schName" :disabled="true" placeholder="请输入您的所属学校名称"></el-input>
          </el-form-item>
          <el-form-item label="几套" prop="pubSet">
            <el-input v-model="ruleForm.pubSet" placeholder="请输入您要申请的书籍套数"></el-input>
          </el-form-item>

          <el-form-item label="申请说明" prop="pubIntro">
            <el-input type="textarea" v-model="ruleForm.pubIntro" placeholder="请输入需求补充说明）"></el-input>
          </el-form-item>

          <div class="subbut" @click="submitForm('ruleForm')">提交信息</div>
          <!-- <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button> -->
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../../assets/api/axios";
export default {
  data() {
    return {
      activeName: '0',
      userData:{},
      types:'',
      publishList:[],
      publishdialogVisible: false,
      ruleForm: {},
      rules: {
        pubBookname: [
          { required: true, message: '请输入图书名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        pubBooknum: [
          { required: true, message: '请输入图书书号', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        pubSet:[
          { required: true, message: '请输入册数', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created(){
    this.loadPublishList();
    this.loadUsermessage();
  },
  methods: {
    async loadUsermessage(){
      var res = await api.post('/front/personal/myMessage')
      console.log("===sssss",res);
      this.userData = res.data;
    },
    getStatusStr(status){
      switch (status) {
        case 0:
          return '未审核'
          break;
        case 1:
          return '审核中'
          break;
        case 2:
          return '已审核'
          break;
        default:
          break;
      }
    },
     async loadPublishList(){
       var res = await api.post('/front/personal/myPublish',{types:this.types})
       this.publishList = res.data;
       this.publishList.forEach(element => {
        element.statusStr = this.getStatusStr(element.pubStatus)
      });
    },
    handleClick(tab, event) {
      if (tab.name === 'all') {
        this.types = '';
      }else{
        this.types = Number(tab.name)
      }
      this.loadPublishList()
    },
    handleClose(done) {
      this.publishdialogVisible = false
    },
    // 表单验证
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("sssss===",this.ruleForm);
          api.post('/front/personal/addPublish',this.ruleForm).then((res) => {
            if(res.code === 1000){
              this.$message.success('申请成功')
              this.publishdialogVisible = false;
              this.loadPublishList();
              this.ruleForm = {};
            }
          }).catch((err) => {
            
          });
          
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.maincen {
  margin: 0 30px;
  min-height: 712px;
}
.catalog {
  overflow: hidden;
  padding: 20px 0 10px;
  border-bottom: 1px solid #e6e6e6;
  .line {
    width: 4px;
    height: 20px;
    background: rgba(181, 14, 5, 1);
    float: left;
    margin-right: 8px;
  }
  .catalogTit {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    float: left;
  }
  .publishBut {
    font-size: 14px;
    float: right;
    color: rgba(181, 14, 5, 1);
    cursor: pointer;
  }
}
.Tit {
  overflow: hidden;
  width: 100%;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  .status {
    width: 50px;
    height: 22px;
    background: rgba(255, 156, 0, 1);
    font-size: 12px;
    color: rgba(254, 254, 254, 1);
    line-height: 22px;
    text-align: center;
    margin-right: 20px;
    float: left;
    margin-top: 13px;
  }
  .restatus {
    background: rgb(5, 85, 14);
  }
  .name {
    float: left;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
  }
  .time {
    float: right;
    margin-right: 40px;
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
  }
}
.details {
  padding-left: 70px;
  .detItem {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 36px;
  }
}
.subbut {
  width: 560px;
  height: 36px;
  background: rgba(181, 14, 5, 1);
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 36px;
  margin: 20px 0 20px;
}
.matbox {
  margin: 0 30px;
  .matTip {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    // margin-bottom: 20px;
    margin: 0 0 20px 30px;
  }
}
</style>

